import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=d41c0f10&scoped=true"
import script from "./AppSettings.vue?vue&type=script&lang=js"
export * from "./AppSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41c0f10",
  null
  
)

export default component.exports